<script lang="ts">
	import { format } from '../../../../services/i18n';
	import type { Device } from '../../../../types/Device';
	import { DEFAULT_DIMMER_VOLTAGE_LIMITS, DEVICES_DIMMER_VOLTAGE_PROTECTION } from 'src/constants';
	import VoltageProtectionOverUnder from './VoltageProtectionOverUnder.svelte';
	import type { VoltageProtectionLimits } from './voltage_protection_constants';

	export let device: Device;

	const limits: VoltageProtectionLimits =
		DEVICES_DIMMER_VOLTAGE_PROTECTION[device.type] ?? DEFAULT_DIMMER_VOLTAGE_LIMITS;

	const defaultUndervoltageLimit = limits.undervoltage.min;
	const defaultOvervoltageLimit = limits.overvoltage.max;

	const defaultsAlertMessage = `
		<ul class="mt-0 mb-0">
			<li>
				${$format('under_voltage_default_v', {
						default: `Under voltage: ${defaultUndervoltageLimit} V`,
						values: { value: defaultUndervoltageLimit },
					})}
			</li>
			<li>
				${$format('over_voltage_default_v', {
						default: `Over voltage: ${defaultOvervoltageLimit} V`,
						values: { value: defaultOvervoltageLimit },
					})}
			</li>
		</ul>`;
</script>

<VoltageProtectionOverUnder
	{device}
	{limits}
	idPrefix="dimmer"
	{defaultsAlertMessage}
	{defaultUndervoltageLimit}
	{defaultOvervoltageLimit}
	showAutoRecovery={false}
	includeSiblingProtectionLimits={true}
/>
